import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import React from 'react';
import { flushSync } from 'react-dom';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { hasPrivilege, PLAYLIST_WRITE } from 'utils/privileges';
import useModalQueryParam from 'hooks/useModalQueryParam';
import Stack from 'components/Stack';
import Button from 'components/Button';
import EmptyStateController from 'components/EmptyStateController';
import PageSection from 'components/PageSection';
import CollectionGrid, { CollectionGridItem } from 'components/CollectionGrid';
import PlaylistEditorModal, { useSubmitPlaylistCreator } from 'screens/PlaylistEditorModal';
import TeamAccessWrapper from '../../../shared/TeamAccessWrapper';
import SmartContentCard from '../../../shared/smartContentCard';
import { useFetchPlaylists } from 'actions/playlists';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export var ADD_PLAYLIST_QUERY_PARAM = 'add-playlist';
function MyTeamPlaylists() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var navigate = useNavigate();
  // Get the teamId from the URL (/my-teams/:teamId)
  var _useParams = useParams(),
    teamId = _useParams.teamId;
  var _useFetchPlaylists = useFetchPlaylists(teamId),
    playlists = _useFetchPlaylists.playlists,
    isLoading = _useFetchPlaylists.isLoading,
    isError = _useFetchPlaylists.isError;
  var _useModalQueryParam = useModalQueryParam(ADD_PLAYLIST_QUERY_PARAM),
    _useModalQueryParam2 = _slicedToArray(_useModalQueryParam, 2),
    hasPlaylistEditorModal = _useModalQueryParam2[0],
    togglePlaylistEditorModal = _useModalQueryParam2[1];
  var _useSubmitPlaylistCre = useSubmitPlaylistCreator({
      ownerTeamId: Number(teamId),
      onSuccess: function onSuccess(newPlaylistId) {
        // flushSync ensures the modal-close history.replace commits a render
        // before history.push, so BackLinkProvider records the clean URL.
        // Without this, React 18 auto-batching merges both into one render
        // and the back link retains ?modal=add-playlist.
        flushSync(function () {
          togglePlaylistEditorModal();
        });
        navigate("/playlists/".concat(newPlaylistId));
      }
    }),
    submitPlaylistCreation = _useSubmitPlaylistCre.submitPlaylistCreation;
  return /*#__PURE__*/_jsx(PageSection, {
    children: /*#__PURE__*/_jsxs(Stack, {
      spacing: "xl",
      children: [/*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Button, {
          variant: "important",
          icon: "plus",
          onClick: togglePlaylistEditorModal,
          children: t('actions_add_playlist')
        }), hasPlaylistEditorModal && /*#__PURE__*/_jsx(PlaylistEditorModal, {
          onSubmit: submitPlaylistCreation,
          onClose: togglePlaylistEditorModal
        })]
      }), /*#__PURE__*/_jsx(EmptyStateController, {
        data: playlists,
        isLoading: isLoading,
        isError: isError,
        height: 300,
        children: /*#__PURE__*/_jsx(CollectionGrid, {
          children: playlists.map(function (playlist) {
            return /*#__PURE__*/_jsx(CollectionGridItem, {
              children: /*#__PURE__*/_jsx(SmartContentCard, {
                content: playlist,
                thumbnailDimensions: "w_757,h_150"
              })
            }, playlist.id);
          })
        })
      })]
    })
  });
}
function ProtectedMyTeamPlaylists() {
  return /*#__PURE__*/_jsx(TeamAccessWrapper, {
    getAdditionalPermissions: function getAdditionalPermissions() {
      return !!hasPrivilege(PLAYLIST_WRITE);
    },
    children: /*#__PURE__*/_jsx(MyTeamPlaylists, {})
  });
}
export default ProtectedMyTeamPlaylists;